(() => {
  if (window.junaidGiftConnected) return;
  window.junaidGiftConnected = true;
  let timer;
  let pending = false;
  let again = false;
  const selector = '[data-junaid-gift]:not([data-gift-mode="banner"])';

  function update(cart) {
    for (const element of document.querySelectorAll(selector)) {
      const config = JSON.parse(element.dataset.giftConfig);
      const threshold = Number(config.threshold);
      if (!Number.isFinite(threshold) || threshold < 0) continue;
      const total = Number(cart.total_price) / 100;
      const hasItems = cart.item_count > 0;
      const qualified = hasItems && total >= threshold;
      const progress = hasItems ? (threshold === 0 ? 100 : Math.min(total / threshold * 100, 100)) : 0;
      const amount = new Intl.NumberFormat(config.locale, {style: 'currency', currency: cart.currency || config.currency}).format(Math.max(threshold - total, 0));
      const message = threshold === 0 ? config.copy.every_order : qualified ? config.copy.qualified : config.copy.progress.replace('[amount]', amount);
      element.querySelector('[data-gift-message]').textContent = message;
      element.querySelector('[data-gift-bar]').style.width = `${progress}%`;
      element.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(progress)));
      element.querySelector('[data-gift-details]').hidden = !qualified;
    }
  }

  async function refresh() {
    if (!document.querySelector(selector)) return;
    if (pending) { again = true; return; }
    pending = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers: {Accept: 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
      if (response.ok) update(await response.json());
    } catch (error) {
      console.warn('Gift progress could not refresh.', error);
    } finally {
      pending = false;
      if (again) { again = false; schedule(); }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 100); }
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:open', 'ajaxProduct:added', 'product:added', 'shopify:section:load'].forEach(name => document.addEventListener(name, schedule));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  schedule();
})();
